<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
<div class="fullContent">
    <div class="containerContent scrollList">
        <v-row>
          <v-col cols="2" lg="3" xl="2" class="pa-0 pr-1">
            <Overview ref="Overview" @filterProvince="filterProvince"/>
          </v-col>
          <v-col cols="6" lg="5" xl="6" style="padding-top: 9px;">
            <v-row>
              <v-col cols="12" class="pt-0 pb-0">
                <Header :provinceDisplay="provinceDisplay"></Header>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pr-1 pb-1">
                <ProvinceList ref="ProvinceList" @resize="resize"/>
              </v-col>
            </v-row>
            <v-row style="height: calc(50% - 25px);">
              <v-col cols="12" class="pr-1">
                <Graph ref="Graph"/>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4" style="padding-right: 25px; max-height: 100%;">
             <div style="text-align: right; height: 65px;" class="pt-0 mr-3">
              <Menu></Menu>
            </div>
            <div style="height: calc(100% - 245px);">
              <Stats ref=Stats @resize="resize"></Stats>
              <Map ref="Map" class="mt-4" />
            </div>           
          </v-col>
        </v-row>
    </div>
  </div>
</template>

<script>
  import Map from '@/components/Map.vue'
  import Overview from '@/components/Overview.vue'
  import ProvinceList from '@/components/ProvinceList.vue'
  import Graph from '@/components/Graph.vue'
  import Menu from '@/components/Menu.vue'
  import Header from '@/components/Header.vue'
  import Stats from '@/components/Stats.vue'

  export default {
    name: 'Dashboard',
    data: () => ({
      provinceDisplay: "",
      summaryData: []
    }),
    components: {
      Map,
      Overview,
      ProvinceList,
      Graph,
      Menu,
      Header,
      Stats
    },
    mounted () {
      //post the GA
      gtag('event', 'page_view', {
        'send_to': 'UA-161523063-1'
      })
    },
    methods: {
      loadCases(summaryCases, provinceDisplay) {
        //store data
        this.summaryData = summaryCases

        this.$refs.Overview.loadCases(summaryCases, provinceDisplay)
        this.$refs.ProvinceList.loadCases(summaryCases, provinceDisplay)
        this.$refs.Map.loadCases(summaryCases, provinceDisplay)
        this.$refs.Graph.loadCases(summaryCases, provinceDisplay)
        this.$refs.Stats.loadCases(summaryCases, provinceDisplay)
      },
      loadLastUpdated(data) {
        this.$refs.Overview.loadLastUpdated(data)      
      },
      loadInterventions(data) {
        this.$refs.Graph.loadInterventions(data)       
      },
      loadGlobalStats(confirmedData, continents) {
        this.$refs.Graph.loadGlobalStats(confirmedData, continents)
      },
      filterProvince(prov) {
        if(prov !== "National") {
          this.provinceDisplay = prov
        }
        else {
          this.provinceDisplay = ""
        }        

        this.loadCases(this.summaryData, this.provinceDisplay)
      },
      resize() {
        this.$refs.Map.resize()
      }
    }
  }
</script>

<style scoped>
.fullContent {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .containerContent {
    height: 100%;
    background: linear-gradient(to bottom left,#216e93,#21648a,#1f5881,#172d5b,#191c51);
    color: #fff;
  }
</style>
